<template>
    <form-section
        id="inspection"
        method="patch"
        :url="url"
        :read_only="read_only"
    >
        <contract-acceptance-date
            v-model="contract_acceptance_date"
            :read_only="read_only"
        />

        <has-inspection
            v-model="has_inspection"
            :read_only="read_only"
        />

        <div v-if="has_inspection">
            <inspection-date
                :inspection="property.inspection"
                :contract_acceptance_date="contract_acceptance_date"
                :read_only="read_only"
            />

            <inspection-contact
                :inspection="property.inspection"
                :read_only="read_only"
            />

            <inspection-scheduled
                :inspection="property.inspection"
                :read_only="read_only"
            />

            <inspection-completed
                :inspection="property.inspection"
                :read_only="read_only"
            />

            <inspection-report-received
                :inspection="property.inspection"
                :read_only="read_only"
            />

            <inspection-report-sent
                :inspection="property.inspection"
                :read_only="read_only"
            />
        </div>
    </form-section>
</template>

<script>
import FormSection from '../../components/form-section.vue';
import ContractAcceptanceDate from '../shared/contract-acceptance-date.vue';
import HasInspection from './has-inspection.vue';
import InspectionDate from './inspection-date.vue';
import InspectionContact from './inspection-contact.vue';
import InspectionScheduled from './inspection-scheduled.vue';
import InspectionCompleted from './inspection-completed.vue';
import InspectionReportReceived from './inspection-report-received.vue';
import InspectionReportSent from './inspection-report-sent.vue';

export default {
    components: {
        FormSection,
        ContractAcceptanceDate,
        HasInspection,
        InspectionDate,
        InspectionContact,
        InspectionScheduled,
        InspectionCompleted,
        InspectionReportReceived,
        InspectionReportSent,
    },

    props: {
        property: {},
        url: {},
        read_only: { default: false },
    },

    data() {
        return {
            contract_acceptance_date: this.property.contract_acceptance_date,
            has_inspection: this.property.inspection.has_inspection,
        }
    },
}
</script>
